import { render } from "./CampaignFormNew.vue?vue&type=template&id=49a8f0a8&scoped=true"
import script from "./CampaignFormNew.vue?vue&type=script&lang=js"
export * from "./CampaignFormNew.vue?vue&type=script&lang=js"

import "./CampaignFormNew.vue?vue&type=style&index=0&id=49a8f0a8&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a8f0a8"]])

export default __exports__